import { useQuery } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";

export interface FunnelData {
  period_days: number;
  total_users: number;
  concept_created: number;
  seeds_added: number;
  trawl_completed: number;
  scoring_completed: number;
  paper_reviewed: number;
  analysis_run: number;
  evidence_attached: number;
  writing_started: number;
}

export function useAdminFunnel(days: number) {
  return useQuery<FunnelData>({
    queryKey: ["admin", "funnel", days],
    queryFn: () => apiClient.get("api/admin/funnel", { searchParams: { days } }).json(),
    retry: false,
  });
}

export interface FeatureAdoptionData {
  period_days: number;
  features: {
    feature: string;
    unique_users: number;
    total_uses: number;
    first_used: string | null;
    last_used: string | null;
    repeat_users: number;
    one_and_done_users: number;
  }[];
  user_matrix: {
    user_id: string;
    name: string;
    features: Record<string, number>;
  }[];
}

export function useAdminFeatureAdoption(days: number) {
  return useQuery<FeatureAdoptionData>({
    queryKey: ["admin", "feature-adoption", days],
    queryFn: () =>
      apiClient.get("api/admin/feature-adoption", { searchParams: { days } }).json(),
    retry: false,
  });
}
